
import ProductList from "./ProductList";

const ProductsList = ({products , showMoreStatus}) => {

    return(
        <>
            {
                products?.map((product) => (
                    <ProductList data={product} collectionData={{isCollection:false , name:'product' , pagination:false}} showMoreStatus={showMoreStatus}/>
                ))
            }
        </>
    )
}


export default ProductsList;